import { Dialog } from '@material-ui/core';
import { version } from '../../package.json';

const AboutModal = ({ open, onClose }) => {
  const buildDate = new Date().toLocaleDateString('pt-BR', {
    day: '2-digit', month: '2-digit', year: 'numeric'
  });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          borderRadius: '16px',
          background: '#172B4D',
          color: '#fff',
          minWidth: '360px',
          overflow: 'hidden',
        }
      }}
    >
      {/* Botão fechar */}
      <div
        onClick={onClose}
        style={{
          position: 'absolute', top: '12px', right: '16px',
          cursor: 'pointer', color: '#aaa', fontSize: '18px', fontWeight: 'bold',
          lineHeight: 1, zIndex: 10
        }}
      >
        ×
      </div>

      {/* Cabeçalho verde */}
      <div style={{
        background: 'linear-gradient(135deg, #62DEC2 0%, #4480A8 100%)',
        padding: '32px 24px 24px',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '40px', marginBottom: '8px' }}>✈️</div>
        <div style={{
          fontFamily: 'Poppins, Arial, sans-serif',
          fontWeight: 700,
          fontSize: '26px',
          color: '#172B4D',
          letterSpacing: '2px',
        }}>
          FULL TOUR
        </div>
        <div style={{
          fontFamily: 'Poppins, Arial, sans-serif',
          fontSize: '13px',
          color: '#172B4D',
          opacity: 0.8,
          marginTop: '4px',
        }}>
          Sistema de Gestão de Passeios
        </div>
      </div>

      {/* Corpo */}
      <div style={{ padding: '24px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            <tr>
              <td style={{ padding: '8px 0', color: '#aaa', fontSize: '13px', width: '120px' }}>VERSÃO</td>
              <td style={{ padding: '8px 0', color: '#62DEC2', fontSize: '13px', fontWeight: 600 }}>
                v{version}
              </td>
            </tr>
            <tr>
              <td style={{ padding: '8px 0', color: '#aaa', fontSize: '13px', borderTop: '1px solid #2a3f5f' }}>BUILD</td>
              <td style={{ padding: '8px 0', color: '#fff', fontSize: '13px', borderTop: '1px solid #2a3f5f' }}>
                {buildDate}
              </td>
            </tr>
            <tr>
              <td style={{ padding: '8px 0', color: '#aaa', fontSize: '13px', borderTop: '1px solid #2a3f5f' }}>DESENVOLVIDO POR</td>
              <td style={{ padding: '8px 0', fontSize: '13px', borderTop: '1px solid #2a3f5f' }}>
                <a
                  href="mailto:marcelobrachile@gmail.com"
                  style={{ color: '#62DEC2', textDecoration: 'none', fontWeight: 600 }}
                >
                  Marcelo Ferreira
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Rodapé */}
      <div style={{
        borderTop: '1px solid #2a3f5f',
        padding: '12px 24px',
        textAlign: 'center',
        color: '#aaa',
        fontSize: '11px',
      }}>
        © {new Date().getFullYear()} Full Tour Chile · Todos os direitos reservados
      </div>
    </Dialog>
  );
};

export default AboutModal;
